import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  // Charge Master
  getAttachments(tenantId: number,allParams:Array<string>=[]) {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){

     allParams.forEach((p: any) => {

       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.GET_ATTACHMENTS.replace('{tenant_id}', tenantId.toString()),
        {headers: this.httpOptions.headers , params: parsedParams}
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSingleAttachment(tenantId: number, attachment_id: number) {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.GET_ATTACHMENT_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{attachment_id}', attachment_id.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  createAttachment(tenantId: number, data: any) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.CREATE_ATTACHMENT.replace('{tenant_id}', tenantId.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateAttachment(tenantId: number, attachment_id: number, data: any) {
    return this.http
      .put(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.UPDATE_ATTACHMENT
          .replace('{tenant_id}', tenantId.toString())
          .replace('{attachment_id}', attachment_id.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  active(tenantId: number, attachment_id: number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.MARK_ATTACHMENT_ACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{attachment_id}', attachment_id.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  inActive(tenantId: number, attachment_id: number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.MARK_ATTACHMENT_INACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{attachment_id}', attachment_id.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  delete(tenantId: number, attachment_id: number) {
    return this.http
      .delete(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.DELETE_ATTACHMENT
          .replace('{tenant_id}', tenantId.toString())
          .replace('{attachment_id}', attachment_id.toString())
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



// DOCUMENTS API 

  uploadDocument(tenantId: number,clientId:number, data: any) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.UPLOAD_DOCUMENT
          .replace('{tenant_id}', tenantId.toString())
          .replace('{client_id}', clientId.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getDocuments(clientId: number,allParams:Array<string>=[]) {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){

     allParams.forEach((p: any) => {

       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.GET_DOCUMENTS.replace('{client_id}', clientId.toString()),
        {headers: this.httpOptions.headers , params: parsedParams}
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getWaiversDocuments(tenantId: number,clientId: number,allParams:Array<string>=[]) {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){
     allParams.forEach((p: any) => {

       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.GET_WAIVERS_DOCUMENTS
          .replace('{tenant_id}', tenantId.toString())
          .replace('{client_id}', clientId.toString()),
        {headers: this.httpOptions.headers , params: parsedParams}
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getClientsWaiverDocuments(clientId: number,allParams:Array<string>=[]) {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){
     allParams.forEach((p: any) => {

       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.GET_CLIENTS_WAIVER_DOCUMENTS.replace('{client_id}', clientId.toString()),
        {headers: this.httpOptions.headers , params: parsedParams}
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSingleDocument(clientId: number, documentId: number) {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.GET_SINGLE_DOCUMENT
          .replace('{client_id}', clientId.toString())
          .replace('{document_id}', documentId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deleteDocument(tenantId: number,clientId: number, documentId:number) {
    return this.http
      .delete(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ATTACHMENT.DELETE_DOCUMENT
          .replace('{tenant_id}', tenantId.toString())
          .replace('{client_id}', clientId.toString())
          .replace('{document_id}', documentId.toString())
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
